"use client"

import { Button } from '@yeshuman/sdk'
import { useState } from 'react'

import type { Brief } from '../../hooks/use-briefs'
import { ReportEmailDialog } from '../employer/report-email-dialog'
import { ShareReportMenu } from '../employer/share-report-menu'
import { RecruiterSearchPanel } from './recruiter-search-panel'

interface BriefSearchTabProps {
  brief: Brief
  onEditBrief?: () => void
}

export function BriefSearchTab({ brief, onEditBrief }: BriefSearchTabProps) {
  const [reportOpen, setReportOpen] = useState(false)

  return (
    <div className="space-y-4">
      <div className="flex justify-end gap-2">
        <ShareReportMenu kind="brief" subjectId={brief.id} />
        <Button type="button" variant="outline" size="sm" onClick={() => setReportOpen(true)}>
          Email report
        </Button>
      </div>
      <ReportEmailDialog
        open={reportOpen}
        onOpenChange={setReportOpen}
        kind="brief"
        subjectId={brief.id}
        asRecruiter
      />
      <RecruiterSearchPanel mode="brief" brief={brief} onEditBrief={onEditBrief} />
    </div>
  )
}
